module.exports = __webpack_public_path__ + "static/media/avado_logo.96ca7dab.svg";